module.exports = __webpack_public_path__ + "static/img/life-proposal0.9f4ca03c.png";